import { Tooltip } from '@/components/ui/tooltip'

interface TooltipProps {
  content: React.ReactNode
  children: React.ReactNode
  side?: 'top' | 'right' | 'bottom' | 'left'
  align?: 'start' | 'center' | 'end'
  delayDuration?: number
  trigger?: 'hover' | 'click'
}

export function SmartTooltip({
  content,
  side = 'top',
  align = 'center',
  delayDuration = 200,
  children,
  trigger = 'hover',
}: TooltipProps) {
  return (
    <Tooltip
      trigger={trigger}
      delayDuration={delayDuration}
      content={content}
      side={side}
      align={align}
      onClick={(e) => e?.stopPropagation()}
    >
      {children}
    </Tooltip>
  )
}
